import React from 'react';

const WorkExperience = ({ workExperiences, formatDate }) => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-100">
      <div className="bg-blue-50 px-6 py-3 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">Work Experience</h3>
      </div>
      <div className="px-6 py-5">
        {workExperiences?.items ? (
          <div className="space-y-8">
            {Array.isArray(workExperiences.items) ? (
              workExperiences.items.map((exp, index) => (
                <div key={index} className="border-b border-gray-100 pb-6 last:border-b-0 last:pb-0">
                  <div className="flex flex-col md:flex-row md:justify-between md:items-start mb-3">
                    <h4 className="text-md font-bold text-gray-900">{exp.position} at {exp.company}</h4>
                    <div className="text-sm bg-blue-50 text-blue-700 px-3 py-1 rounded-full font-medium mt-1 md:mt-0">
                      {formatDate(exp.start_date)} - {exp.end_date ? formatDate(exp.end_date) : 'Present'}
                    </div>
                  </div>
                  {exp.description && (
                    <p className="text-gray-700 mb-4 leading-relaxed">{exp.description}</p>
                  )}
                  {exp.responsibilities && exp.responsibilities.length > 0 && (
                    <div className="mb-4">
                      <h5 className="text-sm font-semibold text-gray-700 mb-2">Responsibilities:</h5>
                      <ul className="list-disc list-outside text-gray-600 text-sm pl-5 space-y-1">
                        {exp.responsibilities.map((resp, idx) => (
                          <li key={idx} className="leading-relaxed">{resp}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {exp.skillsUsed && exp.skillsUsed.length > 0 && (
                    <div>
                      <h5 className="text-sm font-semibold text-gray-700 mb-2">Skills Used:</h5>
                      <div className="flex flex-wrap gap-2">
                        {exp.skillsUsed.map((skill, idx) => (
                          <span key={idx} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-medium">
                            {skill}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="border-b border-gray-100 pb-6">
                <div className="flex flex-col md:flex-row md:justify-between md:items-start mb-3">
                  <h4 className="text-md font-bold text-gray-900">
                    {workExperiences.items.position} at {workExperiences.items.company}
                  </h4>
                  <div className="text-sm bg-blue-50 text-blue-700 px-3 py-1 rounded-full font-medium mt-1 md:mt-0">
                    {formatDate(workExperiences.items.start_date)} - 
                    {workExperiences.items.end_date 
                      ? formatDate(workExperiences.items.end_date) 
                      : 'Present'}
                  </div>
                </div>
                {workExperiences.items.description && (
                  <p className="text-gray-700 mb-4 leading-relaxed">{workExperiences.items.description}</p>
                )}
                {workExperiences.items.responsibilities && 
                 workExperiences.items.responsibilities.length > 0 && (
                  <div className="mb-4">
                    <h5 className="text-sm font-semibold text-gray-700 mb-2">Responsibilities:</h5>
                    <ul className="list-disc list-outside text-gray-600 text-sm pl-5 space-y-1">
                      {workExperiences.items.responsibilities.map((resp, idx) => (
                        <li key={idx} className="leading-relaxed">{resp}</li>
                      ))}
                    </ul>
                  </div>
                )}
                {workExperiences.items.skillsUsed && 
                 workExperiences.items.skillsUsed.length > 0 && (
                  <div>
                    <h5 className="text-sm font-semibold text-gray-700 mb-2">Skills Used:</h5>
                    <div className="flex flex-wrap gap-2">
                      {workExperiences.items.skillsUsed.map((skill, idx) => (
                        <span key={idx} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-medium">
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <p className="text-gray-500 italic">No work experience listed</p>
        )}
      </div>
    </div>
  );
};

export default WorkExperience;
